import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';
import '../../assets/styles/AdminShared.css';

const UserDetails = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleDeleteUser = async () => {
    if (window.confirm('Are you sure you want to delete this user? This action cannot be undone.')) {
      try {
        await deleteDoc(doc(db, 'users', userId));
        alert('User successfully deleted.');
      } catch (error) {
        console.error('Error deleting user:', error);
        alert('Failed to delete user.');
      }
    }
  };

  const handleResetPassword = async () => {
    try {
      if (user.email) {
        await fetch('/api/sendPasswordReset', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: user.email }),
        });
        alert('Password reset email sent.');
      } else {
        alert('User email not found.');
      }
    } catch (error) {
      console.error('Error sending password reset:', error);
      alert('Failed to send password reset.');
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const docRef = doc(db, 'users', userId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setUser(docSnap.data());
      }
      setLoading(false);
    };
    fetchUser();
  }, [userId]);

  if (loading) return <div className="ap-loading"><p>Loading user details...</p></div>;
  if (!user) return <div className="ap-loading ap-loading--error"><p>No user found.</p></div>;

  return (
    <div className="ap-page ap-page--narrow">
      <div className="ap-page-header">
        <a href="/admin" className="ap-back">← Back to dashboard</a>
        <p className="ap-eyebrow">Admin — Client</p>
        <h1 className="ap-title">{user.firstName} {user.lastName}</h1>
      </div>

      <div className="ap-section" style={{ marginBottom: '20px' }}>
        <div className="ap-section-header">
          <h2 className="ap-section-title">Account Info</h2>
        </div>
        <div className="ap-section-body">
          <div className="ap-meta-row" style={{ margin: 0, border: 'none', padding: 0, background: 'transparent' }}>
            <div className="ap-meta-item">
              <span className="ap-meta-label">Name</span>
              <span className="ap-meta-value">{user.firstName} {user.lastName}</span>
            </div>
            <div className="ap-meta-item">
              <span className="ap-meta-label">Email</span>
              <span className="ap-meta-value">{user.email}</span>
            </div>
            {user.projectId && (
              <div className="ap-meta-item">
                <span className="ap-meta-label">Project</span>
                <span className="ap-meta-value">
                  <a href={`/admin/project/${user.projectId}`}>{user.projectId}</a>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ap-section">
        <div className="ap-section-header">
          <h2 className="ap-section-title">Admin Actions</h2>
        </div>
        <div className="ap-section-body">
          <div className="ap-btn-row">
            <button className="ap-btn-secondary" onClick={handleResetPassword}>
              Send Password Reset
            </button>
            <button className="ap-btn-danger" onClick={handleDeleteUser}>
              Delete User
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
